import React from 'react';
import { LinkedinSocialCircle } from 'components/SocialCircle';
import SocialButton, { SocialButtonProps } from './SocialButton';

export interface LinkedInButtonProps
  extends Pick<
    SocialButtonProps,
    'disabled' | 'onClick' | 'params' | 'size' | 'tooltip'
  > {}

const LinkedInButton: React.FC<LinkedInButtonProps> = ({
  disabled,
  onClick,
  size,
  tooltip,
}) => (
  <SocialButton
    icon={<LinkedinSocialCircle />}
    label="LinkedIn"
    {...{ disabled, onClick, size, tooltip }}
  />
);

export default LinkedInButton;
